import { Application, Loader } from 'pixi.js'

// data
import appConfig from '../data/appConfig'
import spriteResources from '../data/sprites'

// systems
import updateP2 from './systems/p2'
import input from './systems/input'
import gameOver from './systems/gameOver'
import updatePixi from './systems/updatePixi'
import { initSpritePool } from './spritePool'
import { levelEditorSystem } from './systems/levelEditor'
import updateParticles, { initParticles } from './systems/particles'
import screenShake from './systems/screenShake'
import { startGameFromMenu } from './systems/startGameFromMenu'
import { pause } from './systems/pause'
import { initStats, statsEnd } from './systems/stats'
import { changeLevelSystem, resetLevelSystem } from './systems/changeLevelSystem'

const app = new Application(appConfig)
app.view.classList.add('walrus-game')
const loader = new Loader()
document.body.appendChild(app.view)

Object.keys(spriteResources).forEach(key => loader.add(key, spriteResources[key]))

loader.load(async ({ resources }) => {
	document.body.classList.add('loading')

	// one off systems
	initStats()
	initSpritePool(resources, app.stage)
	pause(app)
	startGameFromMenu()
	initParticles(resources)

	// update systems
	app.ticker.add((deltaTime) => {
		gameOver()
		updateP2(deltaTime)
		input(deltaTime)
		updatePixi()
		updateParticles()
		screenShake(app.view)
		changeLevelSystem(app)
		resetLevelSystem(app)
		levelEditorSystem(app)
		statsEnd()
	})

	document.body.classList.remove('loading')
})
